<template>
    <div>
        <v-container id="allresearches" fluid tag="section">
            <!-- registered alert -->
            <v-snackbar top v-model="showPwMessage" color="green" class="pl-10">
                <v-icon>mdi-check-circle-outline</v-icon> <span class="font-weight-bold">The password link has been copied to the clipboard!</span>
            </v-snackbar>
            <!-- registered alert -->
            <v-snackbar top v-model="showRegisteredMessage" color="green" class="pl-10">
                <v-icon>mdi-check-circle-outline</v-icon> <span class="font-weight-bold">The user has been added!</span>
            </v-snackbar>
            <!-- exists alert -->
            <v-snackbar top v-model="exists" color="red" class="pl-10">
                <v-icon>mdi-alert-circle-outline</v-icon> <span class="font-weight-bold">{{ existMessage }}</span>
            </v-snackbar>
            <!-- Group change Message -->
            <v-snackbar v-model="showchangeMessage" color="#16C96D" top>
                <v-icon dark size="25">mdi-check</v-icon><span class="font-weight-bold pl-2">User Group was successfully changed!</span>
            </v-snackbar>
            <!-- Change Group Dialog -->
            <v-dialog v-model="changeGroupDialog" max-width="400" height="300px">
                <v-card>
                    <v-card-title>
                        {{ selectedUser ? selectedUser.username : "" }}
                    </v-card-title>
                    <v-card-subtitle>
                        Change Group
                    </v-card-subtitle>

                    <v-card-text>
                        <v-select
                            color="primary"
                            v-model="newgroup"
                            :items="changeGroups"
                            filled
                            prepend-icon="mdi-account-group"
                            label="select new group"
                            item-text="text"
                            item-value="value"
                            return-object
                        >
                            <template v-slot:item="{ item }">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-list-item ripple v-on="on">
                                            <!-- <v-list-item-action>
                          <v-icon :color="companyUser.length > 0 ? 'indigo darken-4' : ''">
                          mdi-close-box
                          </v-icon>
                      </v-list-item-action> -->
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    {{ item.text }}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                    <span>{{ item.description }}</span>
                                </v-tooltip>
                            </template>
                        </v-select>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn rounded class="mx-auto" color="primary" dark @click="changeGroup"> Change Group </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- edit dialog -->
            <v-dialog v-model="editDialog" max-width="500px">
                <v-card>
                    <v-card-title>
                        <span class="headline">Edit Company </span>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.name" label="Dessert name"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.calories" label="Calories"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.fat" label="Fat (g)"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.carbs" label="Carbs (g)"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.protein" label="Protein (g)"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="editDialog = false">
                            Cancel
                        </v-btn>
                        <!-- <v-btn
                color="blue darken-1"
                text
                @click="editDialog = false"
              >
                Save
              </v-btn> -->
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- switch company dialog -->
            <v-dialog v-model="switchCompanyDialog" max-width="500px">
                <v-card>
                    <v-card-title>
                        <span class="headline">Switch Company of {{ this.selectedUser.username }} </span>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-autocomplete
                                        :items="activeCompanies"
                                        v-model="company"
                                        item-text="name"
                                        item-value="company_id"
                                        return-object
                                        label="Company..."
                                        prepend-icon="mdi-office-building-outline"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="switchCompanyDialog = false">
                            Cancel
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="switchCompany()">
                            Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-row justify="center">
                <v-col cols="10">
                    <v-expansion-panels inset>
                        <v-expansion-panel key="1">
                            <v-expansion-panel-header>
                                <v-row>
                                    <v-img src="@/assets/user-illustration.svg" id="userimage"></v-img>
                                    <span id="paneltitle" class="mt-5">All User</span>
                                </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-card class="px-5 py-3 rounded-card">
                                    <v-row>
                                        <v-sheet color="primary" max-height="200" class="pa-12" dark top id="tablesheet" rounded elevation="6">
                                            <div class="headingsheet2">
                                                <v-icon :light="$vuetify.theme.dark ? true : false" id="sheeticon" large>mdi-account</v-icon>
                                            </div>
                                        </v-sheet>
                                        <v-card-title id="heading3">
                                            User
                                        </v-card-title>
                                        <v-spacer></v-spacer>
                                        <v-text-field v-model="userSearch" append-icon="mdi-magnify" label="Search" single-line hide-details id="kwsearch"></v-text-field>
                                    </v-row>

                                    <v-card-text class="mt-5 researchTable">
                                        <v-data-table class="row-pointer" :headers="userHeaders" :items="user" :search.sync="userSearch" multi-sort>
                                            <!-- <template  v-slot:item.listname="{ item }">
          <div @click="onColumnClick(item.listname)"><b id="listnameColumn">{{item.listname}}</b></div>
        </template>
       <template class="spark" v-slot:item.trendData="{ item }">
         <div @click="onColumnClick(item.listname)">
          <v-sparkline
                id="sparkline"
                :value="item.trendData"
                :gradient="gradient"
                smooth="25"
                padding="1.5"
                line-width="0.4"
                width="22"
                height="7"
                stroke-linecap="round"
                gradient-direction="top"
                auto-draw
                :fill="true"
            ></v-sparkline>
         </div>
           
        </template>
        <template  v-slot:item.count="{ item }">
          <div @click="onColumnClick(item.listname)"><v-chip>{{ $helpers.formatNumber(item.count) }}</v-chip></div>
        </template>
        <template  v-slot:item.updated="{ item }">
          <div  @click="onColumnClick(item.listname)"> <v-chip>{{returnDate(item.updated)}} </v-chip></div>
        </template>
        <template  v-slot:item.country="{ item }">
          <div  @click="onColumnClick(item.listname)">
            <v-chip> -->
                                            <!-- <v-avatar left>
                <img :src="fetchCountryFlag(item.country)" class="tablelogos"/>
              </v-avatar> -->
                                            <!-- {{item.country}}
            </v-chip>
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            @click="prepareDeleteItem(item)"
          >
            mdi-delete-outline
          </v-icon> -->
                                            <!-- <v-icon
          class="pl-3"
            @click="share(item)"
          >
            mdi-share-variant-outline
          </v-icon>
        <v-menu
            transition="slide-y-transition"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                class="ml-2"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, i) in items"
                :key="i"
                @click=""
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu> -->
                                            <!-- </template> -->
                                            <template v-slot:item.actions="{ item }">
                                                <v-menu bottom left>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn icon v-on="on">
                                                            <v-icon>mdi-dots-vertical</v-icon>
                                                        </v-btn>
                                                    </template>

                                                    <v-list>
                                                        <!-- <v-list-item @click="editDialog = true">
                                                            <v-list-item-title>Edit</v-list-item-title>
                                                        </v-list-item> -->
                                                        <v-list-item @click="openGroupDialog(item)">
                                                            <v-list-item-title>Change Group</v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item @click="openSwitchCompanyDialog(item)">
                                                            <v-list-item-title>Switch Company</v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item @click="createPasswordCode(item)">
                                                            <v-list-item-title>Create Password Link</v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item v-if="item.content_suite" @click="changeCs(item, 0)">
                                                            <v-list-item-title>Disallow Content Suite</v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item v-if="!item.content_suite" @click="changeCs(item, 1)">
                                                            <v-list-item-title>Allow Content Suite</v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item v-if="item.monitoring_suite" @click="changeMs(item, 0)">
                                                            <v-list-item-title>Disallow Monitoring Suite</v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item v-if="!item.monitoring_suite" @click="changeMs(item, 1)">
                                                            <v-list-item-title>Allow Monitoring Suite</v-list-item-title>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                            </template>
                                        </v-data-table>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel key="2">
                            <v-expansion-panel-header>
                                <v-row>
                                    <v-img src="@/assets/user-illustration.svg" id="userimage"></v-img>
                                    <span id="paneltitle" class="mt-5">Create User</span>
                                </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="text-center">
                                    <div class="my-2" />
                                    <!-- <span class="existMessage">
                    {{existMessage}}
                </span> -->
                                    <form @submit.prevent="register" autocomplete="off">
                                        <v-text-field v-model="username" color="primary" label="Name..." prepend-icon="mdi-face" required />
                                        <v-text-field v-model="email" color="primary" label="Email..." type="email" prepend-icon="mdi-email" @blur="checkIfExists" required />
                                        <v-text-field v-model="password" color="primary" type="password" label="Password..." prepend-icon="mdi-lock-outline" required />
                                        <v-text-field v-model="passwordCheck" color="primary" type="password" label="Confirm Password..." prepend-icon="mdi-refresh" required />
                                        <v-autocomplete
                                            :items="activeCompanies"
                                            v-model="company"
                                            item-text="name"
                                            item-value="company_id"
                                            return-object
                                            label="Company..."
                                            prepend-icon="mdi-office-building-outline"
                                        ></v-autocomplete>
                                        <v-select :items="groups" v-model="group_id" item-text="text" item-value="value" return-object label="Group..." prepend-icon="mdi-account-group"></v-select>
                                        <v-select :items="admin_items" v-model="admin" label="Admin..." prepend-icon="mdi-account-group"></v-select>
                                        <v-select
                                            v-model="selectedlang"
                                            :items="stateItems"
                                            item-text="loc"
                                            item-value="id"
                                            label="Language"
                                            prepend-icon="mdi-map-marker"
                                            return-object
                                            class="mb-8"
                                            color="primary"
                                        >
                                        </v-select>
                                        <v-btn color="primary" outlined type="submit">
                                            Create User
                                        </v-btn>
                                    </form>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
            <!-- delete dialog -->
            <!-- <v-dialog v-model="deleteQuestion" max-width="300">
      <v-card>
        <v-card-title style="{text-align: center}"> Are you sure?</v-card-title>
        <v-card-text class="pb-6 pt-12 text-center">
          <v-btn class="mr-3" text @click="deleteQuestion = false"> Nevermind </v-btn>
          <v-btn color="primary" text @click="deleteItem(selectedDeleteItem)"  >  Yes </v-btn>
        </v-card-text>
        <v-card-actions>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
            <!-- delete alert -->
            <!-- <v-snackbar v-model="deleteSuccess" color="#16C96D" type="success" top >
      <v-icon size="25">mdi-check</v-icon><span class="font-weight-bold pl-2">The selected research has been deleted!</span>
    </v-snackbar> -->
            <!-- Graphlimit Info -->
            <!-- <v-snackbar top color="#fcba03" v-model="noSearchResult">    
           <v-icon>mdi-alert-circle-outline</v-icon> <span class="font-weight-bold pl-2">No keyword found. Please use Keywordplanner or Suggest to get data for this keyword.</span>    
    </v-snackbar> -->
        </v-container>
    </div>
</template>

<script>
    import { validationMixin } from "vuelidate"
    import { required, maxLength, alphaNum } from "vuelidate/lib/validators"

    export default {
        name: "AdminUser",
        mixins: [validationMixin],
        validations: {
            keyword: { required, maxLength: maxLength(30) }
        },

        data: () => ({
            userHeaders: [
                {
                    text: "id",
                    value: "id"
                },
                {
                    text: "Company",
                    value: "company_id",
                    filterable: true
                },
                {
                    text: "mail",
                    value: "user"
                    // algin: 'center', filterable: true
                },
                {
                    text: "username",
                    value: "username",
                    filterable: true
                },
                {
                    text: "verificated",
                    value: "verification_status"
                },
                {
                    text: "plan",
                    value: "plan"
                },
                {
                    text: "group",
                    value: "group_id"
                },
                {
                    text: "content suite",
                    value: "content_suite"
                },
                {
                    text: "monitoring suite",
                    value: "monitoring_suite"
                },
                {
                    text: "requests overall",
                    value: "requestCount"
                },
                {
                    text: "requests 30 days",
                    value: "requestsCounts30Days"
                },
                {
                    // sortable: false,
                    text: "",
                    value: "action"
                },
                { text: "Actions", filterable: false, sortable: false, value: "actions" }
            ],

            user: [],
            userSearch: undefined,
            editDialog: false,
            editedItem: {
                name: "",
                calories: 0,
                fat: 0,
                carbs: 0,
                protein: 0
            },
            editDialog: false,
            switchCompanyDialog: false,
            companies: [],
            company: "",
            selectedUser: {},
            username: "",
            email: "",
            password: "",
            passwordCheck: "",
            showRegisteredMessage: false,
            showPwMessage: false,
            existMessage: "",
            exists: false,
            admin: false,
            admin_items: [0, 1],
            group_id: null,
            groups: [
                // { value: 1, text: "1 - Company Admin" },
                { value: 2, text: "2 - Ready & Write" }
            ], //o = admin , 1 = user

            changeGroupDialog: false,
            newgroup: null,
            changeGroups: [],
            showchangeMessage: false,
            selectedlang: {
                id: 1,
                loc: "German",
                cc: "de"
            },
            stateItems: [
                {
                    id: 1,
                    loc: "German",
                    cc: "de"
                },
                {
                    id: 2,
                    loc: "English",
                    cc: "en"
                },
                {
                    id: 3,
                    loc: "Spanish",
                    cc: "es"
                }
            ],

            auth: "Basic " + window.btoa(process.env.VUE_APP_AUTH)
        }),
        computed: {
            keywordErrors() {
                const errors = []
                if (!this.$v.keyword.$dirty) return errors
                !this.$v.keyword.maxLength && errors.push("Keyword must be at most 30 characters long.")
                !this.$v.keyword.required && errors.push("This field is required.")

                return errors
            },
            activeCompanies() {
                return this.companies.filter((x) => x.status !== "inactive")
            }
        },
        methods: {
            changeCs(item, new_status) {
                this.$http
                    .post(process.env.VUE_APP_APIURL + "/admin/user/cs/change", { company_id: item.company_id, status: new_status, user_id: item.id }, { headers: { Authorization: this.auth } })
                    .then((response) => {
                        console.log(response.body)
                        this.fetchUser()
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            changeMs(item, new_status) {
                this.$http
                    .post(process.env.VUE_APP_APIURL + "/admin/user/ms/change", { company_id: item.company_id, status: new_status, user_id: item.id }, { headers: { Authorization: this.auth } })
                    .then((response) => {
                        console.log(response.body)
                        this.fetchUser()
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            createPasswordCode(item) {
                console.log(item)
                this.$http
                    .post(process.env.VUE_APP_APIURL + "/admin/user/passwordcode/set", { id: item.id }, { headers: { Authorization: this.auth } })
                    .then(async (response) => {
                        console.log(response.body)
                        await navigator.clipboard.writeText(response.body.link)

                        this.showPwMessage = true
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            openGroupDialog(item) {
                this.selectUser(item)
                this.changeGroupDialog = true
                this.fetchGroups(item.company_id)
            },
            changeGroup() {
                console.log(this.newgroup)
                console.log(this.selectedUser)
                let logoutUser = true

                this.$http
                    .post(
                        process.env.VUE_APP_APIURL + "/user/group/switch",
                        { id: this.selectedUser.id, group_id: this.newgroup.value, logoutUser: logoutUser },
                        { headers: { Authorization: this.auth } }
                    )
                    .then((response) => {
                        console.log(response.body)
                        this.changeGroupDialog = false
                        this.fetchUser()
                        this.showchangeMessage = true
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            selectUser(userrow) {
                this.selectedUser = userrow
            },
            openSwitchCompanyDialog(item) {
                this.switchCompanyDialog = true
                this.selectedUser = item
            },
            switchCompany() {
                this.$http
                    .post(process.env.VUE_APP_APIURL + "/user/company/switch", { user_id: this.selectedUser.id, company_id: this.company.company_id }, { headers: { Authorization: this.auth } })
                    .then(function(response) {
                        console.log(response)
                        this.fetchUser()
                        this.fetchCompanies()
                        this.switchCompanyDialog = false
                    })
            },
            fetchUser() {
                this.$http.get(process.env.VUE_APP_APIURL + "/user/list", { headers: { Authorization: this.auth } }).then(function(response) {
                    console.log(response)

                    this.fetchRequests(response.body)

                    // this.userCount = response.body.userCount
                    // this.requestsCount = response.body.requestsCount
                    //   let stats = {};
                    //   this.collectionCount= response.body.stats.count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    //   this.collectionSize = (response.body.stats.storageSize/1014).toFixed(2) + " MB";
                })
            },
            fetchRequests(users) {
                this.$http
                    .get(process.env.VUE_APP_APIURL + "/requests/users/count", { headers: { Authorization: this.auth } })
                    .then((response) => {
                        console.log(response)

                        for (let usersCounter = 0; usersCounter < users.length; usersCounter++) {
                            for (let responseCounter = 0; responseCounter < response.body.requestCounts.length; responseCounter++) {
                                if (response.body.requestCounts[responseCounter].user_id == users[usersCounter].id) {
                                    users[usersCounter].requestCount = response.body.requestCounts[responseCounter].request_count
                                }
                            }
                            for (let response30DaysCounter = 0; response30DaysCounter < response.body.requestsCounts30Days.length; response30DaysCounter++) {
                                if (response.body.requestsCounts30Days[response30DaysCounter].user_id == users[usersCounter].id) {
                                    users[usersCounter].requestsCounts30Days = response.body.requestsCounts30Days[response30DaysCounter].request_count
                                }
                            }
                        }
                        this.user = users
                        console.log(users)
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            fetchCompanies: function() {
                this.$http
                    .get(process.env.VUE_APP_APIURL + "/company/mongoDatabases", { headers: { Authorization: this.auth } })
                    .then((response) => {
                        console.log(response.body)
                        this.companies = response.body
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            register: function() {
                if (this.password == this.passwordCheck) {
                    // this.$matomo.trackEvent("Register", "register", "" , "" )
                    let registerObject = {
                        email: this.email.toLowerCase(),
                        pass: this.password,
                        username: this.username,
                        company_id: this.company.company_id,
                        group_id: this.group_id.value,
                        admin: this.admin,
                        lang: this.selectedlang.cc
                    }
                    this.$http
                        .post(process.env.VUE_APP_APIURL + "/user/registerasadmin", registerObject, { headers: { Authorization: this.auth } })
                        .then((response) => {
                            console.log(registerObject)
                            if (response.body.registered == true) {
                                this.showRegisteredMessage = true
                                this.username = ""
                                this.email = ""
                                this.password = ""
                                this.passwordCheck = ""
                                //console.log(response)
                            }
                        })
                        .catch((error) => {
                            if (error.body.error.notallowed) {
                                // TODO: Website redirect
                                this.notAllowed = true
                                this.notAllowedMessage = "This email adress is not allowed to register. Please contact us: contact@searchinsights.de"
                            } else {
                                //console.log(error)
                            }
                        })
                } else {
                    this.existMessage = "The passwords do not match"
                    this.exists = true
                    this.password = ""
                    this.passwordCheck = ""
                }
            },
            checkIfExists: function() {
                let nameObject = {
                    user: this.email
                }
                this.$http.post(process.env.VUE_APP_APIURL + "/user/namecheck", nameObject, { headers: { Authorization: this.auth } }).then(function(response) {
                    if (response.body.register == false) {
                        this.existMessage = "That email already exists, please try something else"
                        this.exists = true
                        this.email = ""
                    }
                })
            },
            fetchGroups(company_id) {
                this.$http
                    .post(process.env.VUE_APP_APIURL + "/rights/groups/company", { company_id: company_id }, { headers: { Authorization: this.auth } })
                    .then((response) => {
                        console.log(response.body)

                        let mappedGroups = response.body.groups.map((x) => {
                            // console.log(x)
                            let obj = {}
                            obj.text = x.id + " - " + x.name
                            obj.value = x.id
                            obj.description = x.description
                            return obj
                        })

                        this.changeGroups = mappedGroups
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }
        },
        created: function() {
            this.fetchCompanies()
            this.fetchUser()
        }
    }
</script>
<style lang="css" scoped>
    .illustration {
        margin-top: 7% !important;
        margin-left: 15%;
    }
    .chooseMainCard {
        background-color: rgb(243, 243, 243);
        overflow-x: hidden;
    }
    .avat {
        width: 100px;
        height: 100px;
        background-color: var(--v-primary-base);
        border-radius: 50%;
        margin-top: 10px !important;
        margin-left: 5%;
    }
    .chooseCard {
        width: 450px;
        height: 200px;
        background-color: white;
        border-radius: 5px;
        cursor: pointer;
    }
    .chooseCard:hover {
        border: 2px solid var(--v-primary-base);
        box-shadow: 6px 4px 4px #cecece;
    }
    #sparkline {
        max-width: 140px;
    }
    #kwsearch {
        margin-right: 20px !important;
    }
    #heading3 {
        font-weight: 300 !important;
        color: rgb(105, 105, 105);
    }
    .headingsheet {
        margin-top: -15px;
    }
    .headingsheet2 {
        margin-top: -15px;
    }
    #searchsheet {
        margin-top: -30px;
        margin-left: 5px;
        width: 30px;
        height: 30px;
    }
    #tablesheet {
        margin-left: 5px;
        margin-top: -30px;
        width: 60px;
        height: 60px;
    }
    .rounded-card {
        margin-top: 30px;
        /* padding-left: 0px !important;
padding-right: 0px !important; */
    }
    #sheeticon {
        margin-left: -25px;
        margin-top: -25px;
        margin: auto !important;
        padding-bottom: 50% !important;
        width: 50% !important;
    }
    .shortcol {
        max-width: 20% !important;
    }
    .row-pointer >>> tbody tr :hover {
        cursor: pointer;
    }
    .v-card__text {
        padding: 0px !important;
    }
    .v-card__title {
        padding-top: 0px;
    }
    #kwcountCard {
        padding-bottom: 10px !important;
    }
    .v-application .pa-12 {
        padding: 50px !important;
    }
    .searchrow {
        margin: 15px;
    }
    #allresearches {
        padding-top: 30px;
        margin-top: -10px;
    }
    #listnameColumn {
        font-size: 1.1em;
    }
    #userimage {
        margin-left: 5px;
        max-width: 60px !important;
    }
    #paneltitle {
        margin-left: 15px;
        font-size: 1.5em;
        padding-top: auto;
        padding-bottom: auto;
    }
</style>
